// src/components/Carousel/CarouselCard.tsx
import React from "react";
import type { BannerItem } from "../../models/banner.model";
import { useFirstVisitAnimation } from "../../hooks/useFirstVisitAnimation";
import "./Banner.css";

interface BannerCardProps {
	item: BannerItem;
	index: number;
	isFirstVisit: boolean;
}

const BannerCard: React.FC<BannerCardProps> = ({ item, index, isFirstVisit }) => {
	const { animationDone, getDelay, onAnimationEnd } = useFirstVisitAnimation(isFirstVisit);

	return (
		<div
			className={`carousel-card ${item.title === "BONK ART MASTERS" ? "horizontal-card" : ""}`}
			style={{ "--card-color": item.color } as React.CSSProperties}
			onClick={() => window.open(item.link, "_blank")}
		>
			<div
				className={`carousel-card-content-wrapper ${isFirstVisit && !animationDone ? "carousel-first-visit-animation" : ""}`}
				onAnimationEnd={onAnimationEnd}
				style={isFirstVisit && !animationDone ? { animationDelay: getDelay(index) } : {}}
			>
				<div className="carousel-card-image-container">
					<img
						src={item.image}
						alt={item.title}
						className="carousel-card-image"
						style={item.scale ? { transform: `scale(${item.scale})` } : {}}
					/>
				</div>
				<div className="carousel-card-text-container">
					<p className="carousel-card-description">{item.description}</p>
				</div>
			</div>
		</div>
	);
};

export default BannerCard;
